import { metaDataMap } from '../data/metaDataMap';

const getMetaDataDetails = (pathname) => {
  const metaTagDetails = [];
  const categoryIndex = pathname.split('/')[1];
  const subCategoryIndex = pathname.split('/')[2];
  const path = subCategoryIndex || categoryIndex;

  const { title: metaTitle, description: metaDescription } =
    metaDataMap[path] || metaDataMap['default'];

  metaTagDetails.push(metaTitle);
  metaTagDetails.push(metaDescription);
  return metaTagDetails;
};

export default getMetaDataDetails;
